var render = function render(){var _vm=this,_c=_vm._self._c;return _c('indemnity-show',{attrs:{"id":_vm.$route.params.id,"disable-actions":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }